import React, { useState, useEffect } from "react";
import ArrivalReportTable from "../common/tables/ArrivalReportTable";
import { filter } from "lodash";
import store from "../../store/Store";
import Counters from "../common/Counters";

function ArrivalReport() {
  const [getInCounterData, setGetInCounterData] = useState({
    GateIn: "",
    TotalGateIn: "",
  });
  const [userData, setUserData] = useState([])
  const [filteredUserAccessData, setFilteredUserAccessData] = useState([])

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setUserData(Object.values(store.getState().userAccessData))
    });
    return () => {
      unsubscribe();
    };
  });

  useEffect(() => {
    setUserData(Object.values(store.getState().userAccessData))
  },[setUserData]);
  
  useEffect(()=>{
    if(filter(userData,{MenuName:"Arrival Report", View : 1}).length > 0){
      setFilteredUserAccessData(filter(userData,{MenuName:"Arrival Report", View : 1}))
    }
  },[userData])
  return (
    <>
      <div className="df_arrivalDepartureCounter">
        <div className="flex-row mb-12">
          <h1 style={{ marginLeft: "20px" }}>Arrival Report</h1>
        </div>
        {/* <div className="count-container-Gate-In-Out">
          <div className="counter approved">
            Total{" "}
            <span className="count approved-count">
              {getInCounterData.TotalGateIn
                ? getInCounterData.TotalGateIn.length
                : 0}
            </span>
          </div>
        </div>
        <div className="count-container-Gate-In-Out">
          <div className="counter pending">
            Gate In{" "}
            <span className="count pending-count">
              {getInCounterData.GateIn ? getInCounterData.GateIn.length : 0}
            </span>
          </div>
        </div> */}
        <Counters counter={{Total:getInCounterData.TotalGateIn ? getInCounterData.TotalGateIn.length : 0, Gate_In: getInCounterData.GateIn ? getInCounterData.GateIn.length : 0}} label={["Total", "Gate_In"]} styleData = "df_dailyCounterforArrivalReport" />
      </div>
      <ArrivalReportTable
        setGetInCounterData={setGetInCounterData}
        filteredUserAccessData={filteredUserAccessData}
      />
    </>
  );
}
export default ArrivalReport;
